'use client';

import * as React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow, TableCell } from '@/components/ui/table';

interface StoresTableSkeletonProps {
  rows?: number;
}

/**
 * StoresTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export function StoresTableSkeleton({ rows = 8 }: StoresTableSkeletonProps) {
  return (
    <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
      <>
        {Array.from({ length: rows }, (_, index) => (
          <TableRow key={index}>
            {/* Select Checkbox */}
            <TableCell className="w-10">
              <Skeleton height={16} width={16} />
            </TableCell>

            {/* Store Name Badge */}
            <TableCell>
              <Skeleton height={24} width={120} borderRadius="0.75rem" />
            </TableCell>

            {/* Type Badge */}
            <TableCell className="w-20">
              <Skeleton height={20} width={65} borderRadius="0.375rem" />
            </TableCell>

            {/* Base Currency Badge */}
            <TableCell className="w-28">
              <Skeleton height={20} width={45} borderRadius="0.375rem" />
            </TableCell>

            {/* Currencies Count */}
            <TableCell className="w-24">
              <Skeleton height={14} width={75} />
            </TableCell>

            {/* Products Count */}
            <TableCell className="w-20 text-center">
              <Skeleton height={14} width={20} />
            </TableCell>

            {/* Created Date */}
            <TableCell className="w-24">
              <Skeleton height={14} width={70} />
            </TableCell>

            {/* Actions */}
            <TableCell className="w-10">
              <Skeleton height={32} width={32} borderRadius="0.25rem" />
            </TableCell>
          </TableRow>
        ))}
      </>
    </SkeletonTheme>
  );
}
